<div class="sections">
  <div class="section-item" *ngFor="let info of infoList">
    <h2 class="section-title">{{ info.name }}</h2>
    <p class="license">{{ info.licenseType }}</p>
    <a href="{{ info.homepage }}" target="_blank" class="homepage">{{
      info.homepage
    }}</a>

    <div class="license-text">
      <p>{{ info.licenseText }}</p>
    </div>
  </div>
</div>
